import {
	performGetRequest,
	performPostRequest,
} from '@atlassian/jira-fetch/src/utils/requests.tsx';

const featureStatusUrl = (projectKey: string) =>
	`/rest/servicedesk/1/servicedesk/${projectKey}/features/jsm-project-summary`;

const featureEnabledUrl = (projectKey: string) =>
	`/rest/servicedesk/1/servicedesk/${projectKey}/features/enable`;

const FEATURE_NOT_FOUND_STATUS = 404;

export const hasFeatureBeenToggled = async (projectKey: string) => {
	try {
		await performGetRequest(featureStatusUrl(projectKey));
		return true;
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
	} catch (error: any) {
		// It returns 404 when this feature has never been toggled
		if (error?.statusCode === FEATURE_NOT_FOUND_STATUS) {
			return false;
		}

		// If we get an error other than 404, we don't show the spotlight
		return true;
	}
};

export const toggleFeature = async (projectKey: string) => {
	try {
		await performPostRequest(featureEnabledUrl(projectKey), {
			body: JSON.stringify({ feature: 'jsm-project-summary' }),
		});
		return true;
	} catch (error) {
		// TODO: add analytics
		return false;
	}
};
